import React, { useRef } from 'react'
import theme from 'stories/utils/theme'
import { Body1, Headline2, Headline3, Subtitle1 } from 'stories/elements/Typography/Text'
import CollabsibleAccordion from 'components/modules/Accordion/CollapsibleAccordion'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import FAQSchemaData from 'components/modules/SEO/FAQSchemaData'
import { ComponentContainer } from 'components/layouts/Layouts.css'
import _useTranslation from 'lib/hooks/_useTranslation'
import { trackEvent } from 'lib/tracking/analytics-service'
import { AnalyticsEventProPlanFAQClick, AnalyticsEventProPlanSectionImpression } from 'lib/constants/AnalyticsEventType'
import { getReferrerScreen } from 'lib/formatting/url'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import useImpressionTracking from 'lib/hooks/useImpressionTracking'

const Container = styled.div`
    svg {
        path {
            stroke: ${theme.colors.white}99;
        }
    }
    .details {
        p {
            color: ${theme.colors.white};
        }
    }
`

const VariantPlusPlanFAQ = () => {
    const { t } = _useTranslation('plusPlan')
    const md = useMedia(deviceSize.md)
    const router = useRouter()
    const referrerScreen = getReferrerScreen(router)

    const bannerRef = useRef<HTMLDivElement>(null)

    useImpressionTracking(bannerRef, AnalyticsEventProPlanSectionImpression, { referrerScreen, value: 'faqs' })

    const questions = [
        {
            question: t('plusPlan/faqQuestionText1'),
            answer: t('plusPlan/faqAnswerText1'),
            key: 'benefits',
        },
        {
            question: t('plusPlan/faqQuestionText2'),
            answer: t('plusPlan/faqAnswerText2'),
            key: 'payment',
        },
        {
            question: t('plusPlan/faqQuestionText3'),
            answer: t('plusPlan/faqAnswerText3'),
            key: 'renewal',
        },
        {
            question: t('plusPlan/faqQuestionText4'),
            answer: t('plusPlan/faqAnswerText4'),
            key: 'email',
        },
    ]

    const FAQData = questions.map(({ question: title, answer: text, key }) => ({
        title,
        key,
        text: (
            <Body1 color={theme.colors.subtitleBlack} fontFamily="var(--font-inter)" fontWeight={400}>
                {text}
            </Body1>
        ),
    }))

    const Headline = md ? Headline3 : Headline2

    const onPlusPlanFAQToggle = (id: number, key: string) =>
        trackEvent(AnalyticsEventProPlanFAQClick, { valueId: id, value: key, referrerScreen })

    return (
        <ComponentContainer color={theme.colors.transparent}>
            <section id="faq" ref={bannerRef}>
                <Subtitle1
                    color={theme.colors.white}
                    textAlign="center"
                    marginBottom={10}
                    fontWeight={400}
                    fontFamily="var(--font-inter)"
                >
                    FAQ
                </Subtitle1>
                <Headline color={theme.colors.white} textAlign="center" marginBottom={50} fontWeight={700}>
                    {t('plusPlan/faqHeadline')}
                </Headline>
                <FAQSchemaData faqItems={questions} />
                <Container>
                    {FAQData.map((data, i) => (
                        <CollabsibleAccordion
                            hideBorder
                            isDarkTheme
                            key={`faq-question-${i}`}
                            text={data.text}
                            title={data.title}
                            onToggle={() => onPlusPlanFAQToggle(i + 1, data.key)}
                        />
                    ))}
                </Container>
            </section>
        </ComponentContainer>
    )
}

export default VariantPlusPlanFAQ
